import { pharmacyTechniciansRouteStore } from '../domain/store';
import { pharmacyTechnicianUpsertModalRouteStore } from '../domain/upsert-modal-store';

export default () => {
  pharmacyTechnicianUpsertModalRouteStore.setInitialState();
  pharmacyTechniciansRouteStore.setValue('activeTechnicianId', null);
  pharmacyTechniciansRouteStore.setValue('showingUpsertModal', false);
};
